//ScrollTo
(function(a){a.isScrollToFixed=function(b){return !!a(b).data("ScrollToFixed")};a.ScrollToFixed=function(d,i){var m=this;m.$el=a(d);m.el=d;m.$el.data("ScrollToFixed",m);var c=false;var H=m.$el;var I;var F;var k;var e;var z;var E=0;var r=0;var j=-1;var f=-1;var u=null;var A;var g;function v(){H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed");f=-1;E=H.offset().top;r=H.offset().left;if(m.options.offsets){r+=(H.offset().left-H.position().left)}if(j==-1){j=r}I=H.css("position");c=true;if(m.options.bottom!=-1){H.trigger("preFixed.ScrollToFixed");x();H.trigger("fixed.ScrollToFixed")}}function o(){var J=m.options.limit;if(!J){return 0}if(typeof(J)==="function"){return J.apply(H)}return J}function q(){return I==="fixed"}function y(){return I==="absolute"}function h(){return !(q()||y())}function x(){if(!q()){var J=H[0].getBoundingClientRect();u.css({display:H.css("display"),width:J.width,height:J.height,"float":H.css("float")});cssOptions={"z-index":m.options.zIndex,position:"fixed",top:m.options.bottom==-1?t():"",bottom:m.options.bottom==-1?"":m.options.bottom,"margin-left":"0px"};if(!m.options.dontSetWidth){cssOptions.width=H.css("width")}H.css(cssOptions);H.addClass(m.options.baseClassName);if(m.options.className){H.addClass(m.options.className)}I="fixed"}}function b(){var K=o();var J=r;if(m.options.removeOffsets){J="";K=K-E}cssOptions={position:"absolute",top:K,left:J,"margin-left":"0px",bottom:""};if(!m.options.dontSetWidth){cssOptions.width=H.css("width")}H.css(cssOptions);I="absolute"}function l(){if(!h()){f=-1;u.css("display","none");H.css({"z-index":z,width:"",position:F,left:"",top:e,"margin-left":""});H.removeClass("scroll-to-fixed-fixed");if(m.options.className){H.removeClass(m.options.className)}I=null}}function w(J){if(J!=f){H.css("left",r-J);f=J}}function t(){var J=m.options.marginTop;if(!J){return 0}if(typeof(J)==="function"){return J.apply(H)}return J}function B(){if(!a.isScrollToFixed(H)||H.is(":hidden")){return}var M=c;var L=h();if(!c){v()}else{if(h()){E=H.offset().top;r=H.offset().left}}var J=a(window).scrollLeft();var N=a(window).scrollTop();var K=o();if(m.options.minWidth&&a(window).width()<m.options.minWidth){if(!h()||!M){p();H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed")}}else{if(m.options.maxWidth&&a(window).width()>m.options.maxWidth){if(!h()||!M){p();H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed")}}else{if(m.options.bottom==-1){if(K>0&&N>=K-t()){if(!L&&(!y()||!M)){p();H.trigger("preAbsolute.ScrollToFixed");b();H.trigger("unfixed.ScrollToFixed")}}else{if(N>=E-t()){if(!q()||!M){p();H.trigger("preFixed.ScrollToFixed");x();f=-1;H.trigger("fixed.ScrollToFixed")}w(J)}else{if(!h()||!M){p();H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed")}}}}else{if(K>0){if(N+a(window).height()-H.outerHeight(true)>=K-(t()||-n())){if(q()){p();H.trigger("preUnfixed.ScrollToFixed");if(F==="absolute"){b()}else{l()}H.trigger("unfixed.ScrollToFixed")}}else{if(!q()){p();H.trigger("preFixed.ScrollToFixed");x()}w(J);H.trigger("fixed.ScrollToFixed")}}else{w(J)}}}}}function n(){if(!m.options.bottom){return 0}return m.options.bottom}function p(){var J=H.css("position");if(J=="absolute"){H.trigger("postAbsolute.ScrollToFixed")}else{if(J=="fixed"){H.trigger("postFixed.ScrollToFixed")}else{H.trigger("postUnfixed.ScrollToFixed")}}}var D=function(J){if(H.is(":visible")){c=false;B()}else{l()}};var G=function(J){(!!window.requestAnimationFrame)?requestAnimationFrame(B):B()};var C=function(){var K=document.body;if(document.createElement&&K&&K.appendChild&&K.removeChild){var M=document.createElement("div");if(!M.getBoundingClientRect){return null}M.innerHTML="x";M.style.cssText="position:fixed;top:100px;";K.appendChild(M);var N=K.style.height,O=K.scrollTop;K.style.height="3000px";K.scrollTop=500;var J=M.getBoundingClientRect().top;K.style.height=N;var L=(J===100);K.removeChild(M);K.scrollTop=O;return L}return null};var s=function(J){J=J||window.event;if(J.preventDefault){J.preventDefault()}J.returnValue=false};m.init=function(){m.options=a.extend({},a.ScrollToFixed.defaultOptions,i);z=H.css("z-index");m.$el.css("z-index",m.options.zIndex);u=a("<div />");I=H.css("position");F=H.css("position");k=H.css("float");e=H.css("top");if(h()){m.$el.after(u)}a(window).bind("resize.ScrollToFixed",D);a(window).bind("scroll.ScrollToFixed",G);if("ontouchmove" in window){a(window).bind("touchmove.ScrollToFixed",B)}if(m.options.preFixed){H.bind("preFixed.ScrollToFixed",m.options.preFixed)}if(m.options.postFixed){H.bind("postFixed.ScrollToFixed",m.options.postFixed)}if(m.options.preUnfixed){H.bind("preUnfixed.ScrollToFixed",m.options.preUnfixed)}if(m.options.postUnfixed){H.bind("postUnfixed.ScrollToFixed",m.options.postUnfixed)}if(m.options.preAbsolute){H.bind("preAbsolute.ScrollToFixed",m.options.preAbsolute)}if(m.options.postAbsolute){H.bind("postAbsolute.ScrollToFixed",m.options.postAbsolute)}if(m.options.fixed){H.bind("fixed.ScrollToFixed",m.options.fixed)}if(m.options.unfixed){H.bind("unfixed.ScrollToFixed",m.options.unfixed)}if(m.options.spacerClass){u.addClass(m.options.spacerClass)}H.bind("resize.ScrollToFixed",function(){u.height(H.height())});H.bind("scroll.ScrollToFixed",function(){H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed");B()});H.bind("detach.ScrollToFixed",function(J){s(J);H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed");a(window).unbind("resize.ScrollToFixed",D);a(window).unbind("scroll.ScrollToFixed",G);H.unbind(".ScrollToFixed");u.remove();m.$el.removeData("ScrollToFixed")});D()};m.init()};a.ScrollToFixed.defaultOptions={marginTop:0,limit:0,bottom:-1,zIndex:1000,baseClassName:"scroll-to-fixed-fixed"};a.fn.scrollToFixed=function(b){return this.each(function(){(new a.ScrollToFixed(this,b))})}})(jQuery);

/**
 * js-cookie
 */
 !function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function f(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function a(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function e(u){function c(){}function t(e,n,t){if("undefined"!=typeof document){"number"==typeof(t=f({path:"/"},c.defaults,t)).expires&&(t.expires=new Date(+new Date+864e5*t.expires)),t.expires=t.expires?t.expires.toUTCString():"";try{var o=JSON.stringify(n);/^[\{\[]/.test(o)&&(n=o)}catch(e){}n=u.write?u.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=encodeURIComponent(String(e)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var r="";for(var i in t)t[i]&&(r+="; "+i,!0!==t[i]&&(r+="="+t[i].split(";")[0]));return document.cookie=e+"="+n+r}}function n(e,n){if("undefined"!=typeof document){for(var t={},o=document.cookie?document.cookie.split("; "):[],r=0;r<o.length;r++){var i=o[r].split("="),c=i.slice(1).join("=");n||'"'!==c.charAt(0)||(c=c.slice(1,-1));try{var f=a(i[0]);if(c=(u.read||u)(c,f)||a(c),n)try{c=JSON.parse(c)}catch(e){}if(t[f]=c,e===f)break}catch(e){}}return e?t[e]:t}}return c.set=t,c.get=function(e){return n(e,!1)},c.getJSON=function(e){return n(e,!0)},c.remove=function(e,n){t(e,"",f(n,{expires:-1}))},c.defaults={},c.withConverter=e,c}(function(){})});

$(function() {
	
	/* ************** */
	/*    PRODUCT     */
    /* ************** */
    function setEngravingReveal() {
        var engraving_reveal = $("[data-js=engraving_reveal]"); 
    
        $(document).on("click", "[data-js=engraving_reveal_toggle]", function() {
            var $this = $(this);
            $this.toggleClass('js-opened');
    
            if (!$this.hasClass('js-opened')) {
                $this.html($this.data("revert-to"));
    
                engraving_reveal.animate({
                    height: 0
                }, 500);
            } else {
                $this.html('Close Engraving');
    
                engraving_reveal.animate({
                    height: engraving_reveal.get(0).scrollHeight
                }, 500, function(){
                    $(this).height('auto');
                });
            }
        });
    }

    $("body").on("mw_apo", function(event, action) {

        if (action === "end-initialize") {

            if ($(".mw-configure-link-container .edit-options").length) {
                $(".mw-configure-link-container").addClass("sm:tw-ml-4 tw-mt-2 sm:tw-mt-0 mw-configure-link-container tw-text-sm tw-text-blue-bremont tw-border-blue-bremont tw-leading-tight tw-inline-block tw-px-2 tw-py-1 tw-border tw-whitespace-nowrap");
            }
            
            if ($(".mw-options-container").length) {
                var $titleBlockText = $(".engraving-block").find(".mw_product_option_label").contents().get(0).nodeValue;

                if ($(".mw-product-options").hasClass("sa")) {
                    $(".engraving-block").wrap("<div data-js='engraving_reveal' class='tw-h-0 tw-overflow-hidden'><div class='tw-w-full tw-flex tw-flex-col tw-bg-gray-200 tw-p-0 tw-p-6 tw-pb-4'></div></div>");
                } else {
                    $(".engraving-block").wrap("<div data-js='engraving_reveal' class='tw-h-0 tw-overflow-hidden'><div class='tw-w-full tw-flex tw-flex-col tw-bg-gray-200 tw-p-6 tw-pt-8'></div></div>");
                }
                $(".engraving-block .mw-option-description").addClass("tw-text-xs tw-text-center tw-mb-4");

                $("[data-js=engraving_reveal_toggle]").text($titleBlockText).removeClass("tw-hidden").data("revert-to", $titleBlockText);

                setEngravingReveal();
            }

            // Preselect the option based on URL pass
            var urlParams = new URLSearchParams(window.location.search);
            var cfstrap = urlParams.get('cfgstrap');
            if (cfstrap !== null) {
                $('.form-field-input option[value="'+cfstrap+'"]').parent().find('option').removeAttr('selected');
                $('.form-field-input option[value="'+cfstrap+'"]').attr('selected','selected');
            }
    
        }
    
    });

    /* ****************** */
	/*       LISTINGS     */
	/* ****************** */

	var listing_reveal = $('[data-js=reveal_listing]'); 

	$('[data-js=reveal_listing_toggle]').click(function() {
        $(this).toggleClass('js-opened');
        $(this).find('.fa').toggleClass('fa-angle-down fa-angle-up');

        if (!$(this).hasClass('js-opened')) {
            var watch_count = $('[data-js=reveal_listing_text]').data('watch-count');
            
            $('html, body').animate({ scrollTop: $('.productgrid--items').offset().top - 200}, 1000);

            var $this = $(this);

            listing_reveal.animate({
                height: 0
            }, 1000, function() {
                $(this).find('[data-js=reveal_listing_text]').html('View all '+watch_count+' watches');
            });
        } else {
            var $this = $(this);
            listing_reveal.animate({
                height: listing_reveal.get(0).scrollHeight
            }, 1000, function(){
                $(this).height('auto');
                $this.find('[data-js=reveal_listing_text]').html('Collapse watches');
            });
        }
    });
    


    /* ****************** */
	/*  SECTIONS ANYWHERE */
	/* ****************** */
    (function($) {
        $('[data-js=overlay]').click(function(){
            $(this).hide();
            $(this).parent().find('[data-js=video]').fadeIn(350, function(){
                $(this)[0].src += "?autoplay=1";
            });
        });
    })(jQuery);
	
	
	/* ************** */
	/*      HOME      */
	/* ************** */
	//Slideshow play video
	$('.slideshow').on('select.flickity', function( event, index ) {
		$(".slideshow-video").get(0).play();
	});
	
	$(window).scroll(function() {
			if ($(document).scrollTop() > 400) {
					$('.back-top').addClass('active');
			}
			else {
					$('.back-top').removeClass('active');
			}
	});
	
	//Scroll to top
	$('.back_totop, .back-top').click(function() {
		$('html, body').animate({
			scrollTop: 0
		}, 800);
		return false;
	});
	
	
	//Reveal intro contents
	$(".slideshow--section").addClass("waypoint-reveal");
	//$(".section-info-bar").addClass("waypoint-reveal");
	$(".featured-slider").addClass("waypoint-reveal");
	
	
	//Nav menu all watches
	function openMenuWatches() {
		var trigger = $('.navmenu-id-view-all-watches a:not(.is-open)');
		var watches = $('.navmenu-allwatches');
		var meganav = $('.navmenu-meganav--image-container');

		trigger.addClass('is-open');
		meganav.addClass('hidden');
		setTimeout(function(){
			meganav.addClass('none');
			watches.addClass('visible');
		}, 350);
		setTimeout(function(){
			watches.addClass('active');
		}, 500);
		
	}
	
	function closeMenuWatches() {
		var trigger = $('.navmenu-id-view-all-watches a.is-open');
		var watches = $('.navmenu-allwatches');
		var meganav = $('.navmenu-meganav--image-container');
		
		trigger.removeClass('is-open');
		watches.removeClass('active');
		setTimeout(function(){
			watches.removeClass('visible');
			meganav.removeClass('none');
		}, 350);
		setTimeout(function(){
			meganav.removeClass('hidden');
		}, 500);
	}

	
	$(window).on("resize", function () {
			if( $(window).width() < 992) {

					
				$(".navmenu-id-view-all-watches").unbind('click').click(function() {
					$(this).toggleClass('active');
					$(".navmenu-allwatches").slideToggle('slow');
					return false;
				});
				
				$(".navmenu-allwatches > div h4").unbind('click').click(function() {
					$(this).toggleClass('active');
					$(this).next('.navmenu').slideToggle('slow');
					return false;
				});

			} else {
				
			}
	}).resize();
	
	
	
	
	/* ****************** */
	/*   Filter Sticky    */
	/* ****************** */
	$('.productgrid--sidebar').scrollToFixed({
			marginTop: $('.site-header').outerHeight() + 10,
			limit: function() {
					var limit = $('.blogposts--section').offset().top - $('.productgrid--sidebar').outerHeight(true) - 10;
					return limit;
			}
	});
	
	
	
	/* ************** */
	/*   WAYPOINTS    */
	/* ************** */
	$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	function handleWaypoint() {
		setTimeout(function(){
				$('.waypoint').each(function() {
						if ($(this).isInViewport()) {
								$(this).addClass('waypoint-reveal');
						}
				});
		}, 300);
	}

	$(window).on('resize scroll', function() {
        if (template_name != 'product') {   
            handleWaypoint();
        } else {
            $('.waypoint').each(function() {
                $(this).addClass('waypoint-reveal');
            });
        }
	});

	$(document).ready(function() {
        if (template_name != 'product') { 
			handleWaypoint();
        } else {
            $('.waypoint').each(function() {
                $(this).addClass('waypoint-reveal');
            });
        }
	})
	
	
	/* ************** */
	/*    PARALLAX    */
	/* ************** */
	var parallaxElements = [];
	var windowHeight = 0;
	var parallaxSpeed = 2;

	var requestAnimationFrame =
		window.requestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.msRequestAnimationFrame;

	window.requestAnimationFrame = requestAnimationFrame;

	$(document).ready(function() {
		windowHeight = $(window).height();

		//touch event check
		var touchSupported =
			"ontouchstart" in window ||
			(window.DocumentTouch && document instanceof DocumentTouch);

		if (touchSupported) {
			$(window).bind("touchmove", function(e) {
				var scroll = e.currentTarget.scrollY;
				Parallax(scroll);
			});
		} else {
		$(window).bind("scroll", function(e) {
			var scroll = $(this).scrollTop();
			Parallax(scroll);
		});
		}

		$(window).resize(function() {
			windowHeight = $(window).height();
		});
	});

	function Parallax(scrollTop) {

		$('[data-type="parallax"]').each(function() {
			var $this = $(this);
			var parallaxSpeed = $this.data("speed") || 0;
			var offset = $this.offset().top;
			var height = $this.outerHeight(true);

			if (offset + height <= scrollTop || offset >= scrollTop + windowHeight) {
				return;
			}

			var yPos = Math.round((scrollTop - offset) / parallaxSpeed);

			window.requestAnimationFrame(function() {
				$this.css("transform", "translate3d(0, " + yPos + "px, 0)");
				$this.css("-webkit-transform", "translate3d(0, " + yPos + "px, 0)");
			});
		});
	}

	

	
	// Description dropdown
	$('.product-description .dropdown').on( 'click', function() {
		$(this).toggleClass('active');
		$('.product-description--content').slideToggle();
	});
	
	// Strap sizing dropdown
	$('.product-strap-sizing .dropdown').on( 'click', function() {
		$(this).toggleClass('active');
		$('.product-strap-sizing--content').slideToggle();
	});
	
	// Mobile filters dropdown
	$('.show__mobile_filters').on( 'click', function() {
		$(this).toggleClass('active');
		$('.productgrid--sidebar-section').slideToggle();
	});
	
 
	/* ******************** */
	/*      NEWSLETTER      */
	/* ******************** */
	// var nlc = getCookie('newsletter_bar');
	// if(nlc == null) {
	// 	$('[data-js="header-newsletter-bar"]').removeClass('tw-hidden');
	// 	$('main.site-main').addClass('newsletter-bar-active');
	// 	$('.site-header').css({'padding-bottom':'0'});
	// 	setCookie('newsletter_bar','shown');

		
	// 	$('.navmenu-meganav-item-parent').hover(function() {
	// 		$('[data-js="header-newsletter-bar"]').toggleClass('tw-hidden');
	// 	});
	// }

	
	/* ******************** */
	/*   CURRENCY SWITCH    */
	/* ******************** */
	$(".currency-switcher-selected-entry").on("click", function(){
		$(this).toggleClass("active");
		$(this).next('.currency-switcher-entry').slideToggle(150);
	});
	
	function runRedirect(sitesubdomain) {
	 	var hn = window.location.hostname;
		// console.log(sitesubdomain);
		if(hn == 'www.bremont.com' && sitesubdomain == '') {
			var wl = window.location.href;
			var nwl = wl.replace('https://www.','https://us.');
			window.location.href = nwl;
		} else if(hn == 'www.bremont.com' && sitesubdomain == 'aus') {
			var wl = window.location.href;
			var nwl = wl.replace('https://www.','https://au.');
			window.location.href = nwl;
		}
	}
	
	
	var gc = getCookie('siteversion');
	if(gc == null) {
		$.ajax({
			url: 'http://api.ipstack.com/check?access_key=37064f7b79115a2c5939e3fc57f721bd&format=1', 
			type: 'POST',
			dataType: 'json',
			success: function (location) {
				//console.log(location);
				if(location.continent_code == 'NA' || location.continent_code == 'SA') {
					setCookie('siteversion','usnew'); 
					runRedirect();
				} else if(location.country_code == 'AU' || location.continent_code == 'OC') {
					setCookie('siteversion','ausnew'); 
					runRedirect('aus');
				} else {
					setCookie('siteversion','uk');    
				}
			}
		});
		
	} else if(gc == 'usnew') {
		 $(".currency-switcher-selected-entry").addClass('highlight');
		 setCookie('siteversion','us'); 
		
	}  else if(gc == 'ausnew') {
		 $(".currency-switcher-selected-entry").addClass('highlight');
		 setCookie('siteversion','aus'); 
		
	} else if (gc == 'us') {
	 	runRedirect();
		setCookie('siteversion','us');
		
	}
	
	function setCookie(key, value) {
		 var expires = new Date();
		 expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
		 document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() +';domain=bremont.com';
	}

	function getCookie(key) {
		 var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		 return keyValue ? keyValue[2] : null;
	}
	
	
	//Product video modal
//   $(".video__modal").on("click", function(){
//     $(".product-ender--mask").addClass("active");
//     $('#videoModal').get(0).play();
//   });

//   function closeVideoModal(){
//     $(".product-ender--mask").removeClass("active");
//   }

//   $(".product-ender--modal .close, .product-ender--mask").on("click", function(){
//     closeVideoModal();
//     $('#videoModal').get(0).pause();
//   });

//   $(document).keyup(function(e) {
//     if (e.keyCode == 27) {
//       closeVideoModal();
//     }
//   });
	
	
	/* ****************** */
	/*   ENQUIRY MODAL    */
	/* ****************** */
	$(".open__enquiry_form, .register__interest").on("click", function(){
		$(".enquiry-form--mask").addClass("active");
	});
	
	$('.form-options select').each(function(i,v) {
		var runhide = true;
		
		$(v).children('option').each(function() {
			
			if($(this).attr('disabled') != true) {
				runhide = false;
			}
			
		});
		if(runhide == true) {
		 v.hide(); 
		};
		// console.log('runhide',runhide);
			
	});

	function closeEnquiryModal(){
		$(".enquiry-form--mask").removeClass("active");
	}

	$(".enquiry-form--modal .close, .enquiry-form--mask").on("click", function(){
		closeEnquiryModal();
	});

	$(document).keyup(function(e) {
		if (e.keyCode == 27) {
			closeEnquiryModal();
		}
	});

	
	/* ************** */
	/*     SEARCH     */
	/* ************** */
	$('.search__btn').on('click', function(e) {
		e.stopPropagation();
		
		$('.live-search').show().animate({
			opacity: "1"
		}, 500);
		$('.live-search').addClass('active');
		$('.search__close').addClass('active');
		
		$('.live-search-form-field').focus();
	});
	
	$('.search__close').on( 'click', function() {
		$('.live-search').animate({
			opacity: "0"
		}, 500);
		
		setTimeout(function(){
			$('.live-search').hide();
			$('.live-search').removeClass('active');
			$('.search__close').removeClass('active');
		}, 500);
	});
	
	
	// Languages modal
	$('.language-switch__locale').on( 'click', function() {
		$('.language-switch__panel').show().animate({
			left: "0"
		}, 500);
	});
	
	$('.language-switch__btn_close').on( 'click', function() {
		$('.language-switch__panel').animate({
			left: "-100%"
		}, 500);
		
		setTimeout(function(){
			$('.language-switch__panel').hide();
		}, 500);
	});
	
	
	
	/* ************** */
	/*    FILTERS     */
	/* ************** */
	$('.productgrid--sidebar-title--small').on( 'click', function() {
		$(this).toggleClass('active');
		$(this).next('ul').slideToggle();
	});
	
	$('.filter-item--active').parent().addClass('active');
	$('.filter-item--active').parent().prev('.productgrid--sidebar-title--small').addClass('active');


	
	/* ******************* */
	/*   RELATED SLIDER    */
	/* ******************* */
	$(".related-carousel-main").each(function() {
        $(this).owlCarousel({
            loop: false,
            nav: true,
            margin: 24,
            dots: false,
            center: true, 
            responsive: {
                0: {
                    items: 2
                },
                640: {
                    items: 3
                },
                1240: {
                    items: 5
                }
            }
        });
    }); 
    
    $(".related-carousel-pdp").each(function() {
        $(this).owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1,
                    center: true,
                    margin: 0,
                    stagePadding: 70
                },
                640: {
                    items: 3,
                    center: false,
                    margin: 24,
                    stagePadding: 0
                },
                1240: {
                    items: 5
                }
            }
        }); 
	});
	
	
	/* *************** */
	/*   NEWSLETTER    */
	/* *************** */
	$('.newsletter-focus').on('click', function() {
		$('.form-fields-reveal').slideDown();
	});
	
	$('.newsletter__close').on('click', function() {
		$('.form-fields-reveal').slideUp();
	});
	
	
	
	/* *********************** */
	/*   PRODUCT IMAGE ZOOM    */
	/* *********************** */
//   $(window).on("resize", function () {
//     if( $(window).width() > 992) {
//       var productImageZoom = $('.product-gallery--image.image--selected img').attr('href');
//       $('.product-gallery--image').zoom({url: productImageZoom});
//     } else {} 
		
//    }).resize();
	
	
	
	/* *********************** */
	/*   POPUP INPUT FILLED    */
	/* *********************** */
	function initInputBlur() {
		$('.newsletterpopup .form-field-input').on('blur', function(event) {
			
			var inputValue = this.value;
			if (inputValue) {
				$(this).addClass('form-field-filled');
			} else {
				$(this).removeClass('form-field-filled');
			}
		});
	}

	//init
	initInputBlur();
	
	
	/* *********************** */
	/*        BOUTIQUES        */
	/* *********************** */
	$('.view__form').on( 'click', function(e) {
		e.preventDefault();
		$('html, body').animate({
					scrollTop: $(".section-boutique-form").offset().top - 100
		}, 1000);
	});
	
	
	/* *********************** */
	/*      FAQ ACCORDION      */
	/* *********************** */
	$('.accordion').find('.accordion-toggle').click(function(){
		$(this).next().slideToggle();
		$(this).toggleClass('active');
//     $(".accordion-content").not($(this).next()).slideUp();

//     $('html, body').animate({
//           scrollTop: $(this).offset().top - 100
//     }, 500);
	});
	
	
	
	
	/* *********************** */
	/*       WECHAT MODAL      */
	/* *********************** */
	$('.social-link_wechat').on('click', function(e){
		e.preventDefault();
		
		$(".modal-wechat_mask").addClass("active");
	});

	function closeModalWechat(){
		$(".modal-wechat_mask").removeClass("active");
	}

	$(".modal-wechat .close, .modal-wechat_mask").on("click", function(){
		closeModalWechat();
	});

	$(document).keyup(function(e) {
		if (e.keyCode == 27) {
			closeModalWechat();
		}
	});
	

	/* *********************** */
	/*     SEARCH REDIRECT     */
	/* *********************** */
	var locationsArray = ['london', 'new york', 'newyork', 'melbourne', 'hong kong', 'hongkong', 'mayfair', 'city of london', 'canary wharf', 'france', 'australia', 'berlin', 'dubai', 'frankfurt', 'hamburg', 'münchen', 'munchen', 'sydney', 'bremen', 'brisbane', 'germany', 'japan'];

	$(document).on('change', '.live-search-form-field', function() {
		var val = $(this).val().toLowerCase();

		if ($.inArray(val, locationsArray) > -1) {
				$('form.live-search-form').on('submit',function(){
						window.location.href = "/pages/store-locator";
				});
				$("button.live-search-button").on('click', function() {
						window.location.href = "/pages/store-locator";
				});
		}
	});
	
	$(document).on('change', '.productgrid--search-form-field', function() {
		var val = $(this).val().toLowerCase();

		if ($.inArray(val, locationsArray) > -1) {
				$('form.productgrid--search-form').on('submit',function(){
						window.location.href = "/pages/store-locator";
					});
		}
	});

  
  $('.product__finance__title').on('click', function(){
    
    var initialHeight; 
    var newHeight;
    var target = $(".product__finance__wrap").first();
    
    $(this).toggleClass("expanded");
    $(".plus-icon").toggleClass('open');
    $(".plus-icon").toggleClass('closed');
    
    if($(this).hasClass("expanded")){
      initialHeight = $(target).outerHeight();
      $(target).css("height", "auto");
      $(window).trigger("resize");
      newHeight = $(".product__finance__wrap").outerHeight();
      $(target).css("height", initialHeight+"px");

      $(target).animate({"height": newHeight+"px"}, function(){
        $(target).css("height", "auto");
      });
      
    } else {
      initialHeight = $(target).outerHeight();
      $(target).css("height", "");
      newHeight = $(".product__finance__wrap").outerHeight();
      $(target).css("height", initialHeight+"px");

      $(target).animate({"height": newHeight+"px"}, function(){
        $(target).css("height", "");
      });
    }

  });

  
}); 

	/* *********************** */
	/*        LISTINGS         */
	/* *********************** */

$(document).ready(function() {
    // Configurator
    var fromConfigurator = Cookies.get("configurator");

    if (fromConfigurator !== undefined) {
        var backToConfigurator = $("[data-js='to-configurator']");

        if (backToConfigurator.length > 0) {
            Cookies.remove("configurator", { domain: ".bremont.com" });
            backToConfigurator.show();
        }
    }

    if (fromConfigurator === undefined) {
        var toConfigurator = $("[data-js='banner-configurator']");

        if (toConfigurator.length > 0) {
            toConfigurator.show();
        }
    }

    var fromStrapConfigurator = Cookies.get("strap_configurator");
    var referrer = document.referrer;
    var search = 'straps.bremont.com';
    
    if (fromStrapConfigurator !== undefined && referrer.indexOf(search) > -1) {
        var backToConfiguratorStrap = $("[data-js='to-configurator-straps']");

        if (backToConfiguratorStrap.length > 0) {
            Cookies.remove("strap_configurator", { domain: ".bremont.com" });
            backToConfiguratorStrap.show();
        }
    }

    // If have CRMID in the URL, set a cookie with that value
  	var DLCRMID = Cookies.get('DLCRMID');
    if (DLCRMID !== undefined) {
        checkFormCrmID();
    }

    var urlParams = new URLSearchParams(window.location.search);
    var crmid = urlParams.get('crmid');
  if (crmid == null) {
    var crmid = urlParams.get('CRMID');
  }
    if (crmid !== null) {
        Cookies.set("DLCRMID", crmid, { domain: ".bremont.com" });

        checkFormCrmID();
    }

    var DLSOURCEID = Cookies.get('DLSOURCEID');
    if (DLSOURCEID !== undefined) {
        if ($('input[name=powf_8b3b770a0297e711810f70106faa9741]').length > 0) { $('input[name=powf_8b3b770a0297e711810f70106faa9741]').val(Cookies.get('DLSOURCEID')); return true; }
    }

    var urlParams = new URLSearchParams(window.location.search);
    var crmid = urlParams.get('sourceid');
   if (crmid == null) {
    var crmid = urlParams.get('SOURCEID');
  }
    if (crmid !== null) {
        Cookies.set("DLSOURCEID", crmid, { domain: ".bremont.com" });

        if ($('input[name=powf_8b3b770a0297e711810f70106faa9741]').length > 0) { $('input[name=powf_8b3b770a0297e711810f70106faa9741]').val(Cookies.get('DLSOURCEID')); return true; }
    }
});



function checkFormCrmID() {
    //  Campaign ID
    if ($('input[name=powf_84c85bfe0197e711810f70106faa9741]').length > 0) { $('input[name=powf_84c85bfe0197e711810f70106faa9741]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_e321180810b3e711811570106faa9741]').length > 0) { $('input[name=powf_e321180810b3e711811570106faa9741]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_e1e44aae0197e711810f70106faa9741]').length > 0) { $('input[name=powf_e1e44aae0197e711810f70106faa9741]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_2bf305b9fe96e711810f70106faa9741]').length > 0) { $('input[name=powf_2bf305b9fe96e711810f70106faa9741]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_a9412fcd0197e711810f70106faa9741]').length > 0) { $('input[name=powf_a9412fcd0197e711810f70106faa9741]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_e421180810b3e711811570106faa9741]').length > 0) { $('input[name=powf_e421180810b3e711811570106faa9741]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_ccdef80950a8e711811270106fa7b041]').length > 0) { $('input[name=powf_ccdef80950a8e711811270106fa7b041]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_c5222da7fd68e811814370106fa68211]').length > 0) { $('input[name=powf_c5222da7fd68e811814370106fa68211]').val(Cookies.get('DLCRMID')); return true; }
    if ($('input[name=powf_2bf305b9fe96e711810f70106faa9741]').length > 0) { $('input[name=powf_2bf305b9fe96e711810f70106faa9741]').val(Cookies.get('DLCRMID')); return true; }
}





/**
 * PDP
 */
$(document).on("change", "select[data-product-option]", function(){
    var image = $("select[name=id]").find(":selected").data("variant-image");
    var index = $(document).find(".mz-thumb[data-image='"+image+"']").parent().data("item");
    MagicZoom.switchTo('zoom-group', index);
});
$(document).ready(function() {
    var image = $("select[name=id]").find(":selected").data("variant-image");
    if (image != undefined && image.search("no-image") == -1) {
        $(".zoom-gallery-slide .MagicZoom figure > img").attr("src", image).attr("srcset", image);
    }

    var index = $(document).find(".mz-thumb[data-image='"+image+"']").parent().data("item");
    if (typeof isEType == 'undefined') {
        setTimeout(function() { $(".zoom-gallery-slide").removeAttr("style"); }, 100);
        MagicZoom.switchTo('zoom-group', index);
    }
  setTimeout(function() { $(".zoom-gallery").removeAttr("style"); }, 2000);
});

var consentCookie = Cookies.get("eg_cookieconsent_status");
if (consentCookie){
    window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
}

$(document).on('click', '.eg-cc-dismiss', function() {
  window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
});


$(document).on('click', '[data-js="show-strap-box"]', function() {
    $('.strap-frame').slideDown(200, function() {
        var top = $('.strap-frame').offset().top - 150;
        $('html,body').animate({scrollTop: top}, 1000);
        return false;
    })
});